import React, { useState } from 'react'
import PointsQuarterAndMonthChart from 'Components/dashboard/charts/PointsQuarterAndMonthChart.js'
import useDashboardData from 'Components/dashboard/useDashboardData.js'
import _ from 'lodash'
import moment from 'moment'

export default function PointsRemainingChart(props) {
  const [data, loadingState] = useDashboardData('reports/wallet-points-remaining')
  const [calenderToggle, setCalenderToggle] = useState(null)
  const [endDate, setEndDate] = useState(moment().format())

  function formatMoment(input) {
    return moment(input).format('YYYY-MM-DD')
  }

  const getFilterDetails = () => {
    window.open(`/all-unused-point/endDate=${formatMoment(endDate)}`)
    setFilterToggle()
    setEndDate(moment().format())
  }

  function setFilterToggle() {
    setCalenderToggle(prev => (prev === true ? false : true))
  }

  return (
    <PointsQuarterAndMonthChart
      header={props.isWalletActivation ? 'Ubrugte shop point' : 'Ubrugte point'}
      state={loadingState}
      monthlyData={_.map(_.get(data, 'monthlyResults'), value => ({
        Month: moment(value.month, 'MM/YYYY').format('MMM YY'),
        Ubrugte: value.remaining
      }))}
      quarterlyData={_.map(_.get(data, 'quarterlyResults'), value => ({
        Month: moment(value.month, 'Q/YYYY').format('Qo[kvt.] YYYY'),
        Ubrugte: value.remaining
      }))}
      keys={['Ubrugte']}
      indexBy={'Month'}
      legends={[]}
      getFilterDetails={getFilterDetails}
      setFilterToggle={setFilterToggle}
      calenderToggle={calenderToggle}
      showIcon={true}
      endDate={endDate}
      setEndDate={setEndDate}
    />
  )
}
